import React from "react";

function RelevantReports({ relatedReports }) {
  // Report data (replace with your actual URLs)
  // const reports = [
  //   { title: "Civil Engineering Market Outlook", url: "/path-to-report1" },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report2",
  //   },
  //   { title: "Civil Engineering Market Outlook", url: "/path-to-report3" },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report4",
  //   },
  //   { title: "Civil Engineering Market Outlook", url: "/path-to-report5" },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report6",
  //   },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report6",
  //   },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report6",
  //   },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report6",
  //   },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report6",
  //   },
  //   {
  //     title: "Battery Contract Manufacturing Market Outlook",
  //     url: "/path-to-report6",
  //   },
  // ];
  console.log(relatedReports, "relatedReports");
  return (
    <div className="bg-white p-4 rounded-lg flex flex-col justify-between shadow-lg max-w-sm border1 mt-2">
      <h3 className="font-bold mb-4 font-inter font4">
        Relevant Market Reports
      </h3>

      <ul className="max-h-96 overflow-y-auto scrollbar-hide">
        {relatedReports?.map((report, index) => (
          <li key={index} className="flex items-start space-x-4 mb-2">
            <img
              src="images/lab_profile.png"
              alt="Lab Profile"
              className="w-5 h-5 object-contain flex-shrink-0 mt-1"
            />
            <a
              href={""}
              className="hover:underline text-sm font-inter flex-grow"
              target="_blank"
              rel="noopener noreferrer"
            >
              {
                report?.reportTitle.replace(/\b(Size Study)\b/gi, "") // Remove unwanted words
              }
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RelevantReports;
